import { FarcanaAuthResponse, FarcanaStatsResponse } from './types'
import { http } from '@/shared/http.ts'

export const getFarcanaAuthLink = async (token: string): Promise<FarcanaAuthResponse> => {
  return await http.get<FarcanaAuthResponse>('/integration/farcana/auth', {
    token,
  })
}

export const getFarcanaStats = async (token: string): Promise<FarcanaStatsResponse> => {
  return await http.get<FarcanaStatsResponse>('/integration/farcana/statistic', {
    token,
  })
}

export const getShareLink = async (token: string) => {
  return await http.get<{ message_id: string, expiration_date: string }>('/integration/share', {
    token,
  })
}
export const getAppStatus = async (token: string): Promise<boolean> => {
  return await http.get<boolean>('/integration/app-status', {
    token,
  })
}
